// Progressive enhancement only. Shopify owns cart totals, forms and checkout.
export function validVariant(value         )                  {
  return typeof value === 'string' && /^[1-9]\d{0,17}$/.test(value);
}
                                                                                                          
                                               
export function buildBundleItems(variants                ,choices               )                                                               {
  if(choices.length!==2&&choices.length!==4)throw Error('Invalid bundle size');
  for(const choice of choices){if(!variants.some(v=>v.available&&v.color===choice.color&&v.height===choice.height&&v.pack==='זוג כריות'&&validVariant(v.id)&&v.priceCents===39900))throw Error('Unavailable pillow selection');}
  const items=[];
  for(let i=0;i<choices.length;i+=2){
    const first=choices[i],second=choices[i+1];if(!first||!second)throw Error('Missing pillow choice');
    const variant=variants.find(v=>v.available&&v.color===first.color&&v.height===first.height&&v.pack==='זוג כריות'&&validVariant(v.id)&&v.priceCents===39900);if(!variant)throw Error('Invalid pair variant');
    const properties                      ={'כרית 1':`${first.color} · ${first.height}`,'כרית 2':`${second.color} · ${second.height}`};
    if(choices.length===4)properties['מארז']='4 כריות · זוג '+(i/2+1)+' מתוך 2';
    items.push({id:variant.id,quantity:1,properties});
  }
  return items;
}

// D32: the cart offers a second pillow to a cart with a single one. The pair is added first and only then
// is one single taken out, so a failed request never leaves the cart with less than it had. No retries.
export function mountCartUpsell(root             = document)       {
  root.querySelectorAll             ('[data-pair-upgrade]').forEach(card => {
    if (card.dataset.upsellMounted === 'true') return;
    const button = card.querySelector                   ('[data-pair-add]');
    const status = card.querySelector             ('[data-pair-status]');
    const data = card.querySelector                   ('script[data-pair-variants]');
    const label = card.querySelector             ('[data-selected-color]');
    if (!button || !status || !data) return;
    let variants                 ;
    try { variants = JSON.parse(data.textContent ?? '[]')                   ; } catch { return; }
    const cart = new URL(card.dataset.cartUrl ?? '/cart', location.origin);
    if (cart.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart\/?$/.test(cart.pathname)) return;
    card.dataset.upsellMounted = 'true';
    const base = cart.pathname.replace(/\/$/, '');
    const post = (path        , body         )                => fetch(new URL(base + path, location.origin), {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'same-origin', body: JSON.stringify(body), signal: AbortSignal.timeout(30000)}).then(response => { if (!response.ok) throw Error('Cart request failed'); });
    const fail = (message        )       => {
      status.textContent = message;
      const link = document.createElement('a'); link.href = cart.href; link.textContent = 'לבדיקת הסל'; status.append(link);
      button.textContent = 'יש לבדוק את הסל';
    };
    card.addEventListener('change', event => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.matches('[data-upsell-color]') && label) label.textContent = target.value;
      status.textContent = '';
    });
    button.addEventListener('click', () => {
      if (button.disabled) return;
      const first = {color: card.dataset.firstColor ?? '', height: card.dataset.firstHeight ?? ''};
      const second = {color: card.querySelector                  ('[data-upsell-color]:checked')?.value ?? '', height: card.querySelector                  ('[data-upsell-height]:checked')?.value ?? ''};
      let items                                     ;
      try { items = buildBundleItems(variants, [first, second]); } catch { status.textContent = 'יש לבחור צבע וגובה זמינים לכרית השנייה.'; return; }
      const key = card.dataset.lineKey ?? '';
      const quantity = Number(card.dataset.lineQuantity);
      if (!key || !Number.isInteger(quantity) || quantity < 1) return;
      button.disabled = true; button.textContent = 'מוסיפים לסל…';
      void post('/add.js', {items}).then(
        () => post('/change.js', {id: key, quantity: quantity - 1}).then(() => location.assign(cart.href), () => fail('הזוג נוסף, אבל הכרית הבודדת עדיין בסל. אפשר להסיר אותה ידנית. ')),
        () => fail('לא התקבל אישור הוספה. יש לבדוק את הסל לפני ניסיון נוסף. '));
    });
  });
}

export function mount(root             = document)       {
  mountCartUpsell(root);
  root.querySelectorAll                 ('form.buy-form').forEach(form => {
    if (form.dataset.purchaseMounted === 'true') return;
    const select = form.querySelector                   ('[name="id"]');
    const purchase = form.closest             ('[data-purchase]') ?? form;
    const amounts = purchase.querySelectorAll             ('[data-selected-price]');
    const submit = form.querySelector                   ('[type="submit"]');
    const quantity=form.querySelector                  ('[name="quantity"]');
    if (!select || !submit || !quantity) return;
    form.dataset.purchaseMounted = 'true';

    // Shopify's actual36 variants remain the submitted source of truth.
    const bundleOptions = form.querySelector                     ('[data-bundle-options]');
    const radios = Array.from(purchase.querySelectorAll                  ('[data-choice-radio]'));
    const packRadios = radios.filter(radio => radio.dataset.optionPosition === '2');
    const options = Array.from(select.options);
    const extraChoices=Array.from(form.querySelectorAll             ('[data-pillow-choice]'));
    const colorRadios=Array.from(form.querySelectorAll                  ('[data-pillow-color]'));
    const heightRadios=Array.from(form.querySelectorAll                  ('[data-pillow-height]'));
    const selectionGroup=form.querySelector             ('[data-pillow-choices]');
    const selectionStatus=form.querySelector             ('[data-bundle-status]');
    const selectionInstruction=form.querySelector             ('[data-choice-instruction]');
    let bundleInFlight=false;
    const familyDiscount=/^\d{1,6}$/.test(bundleOptions?.dataset.familyDiscountCents??'')?Number(bundleOptions?.dataset.familyDiscountCents):0;
    const familyTotal=(pairCents       )       =>Math.max(0,pairCents*2-familyDiscount);
    const keys = ['color','height','pack']         ;
    const money=(cents       )       =>new Intl.NumberFormat('he-IL',{style:'currency',currency:'ILS',maximumFractionDigits:2}).format(cents/100);
    const colorValues=new Set(options.map(option=>option.dataset.color??'').filter(value=>value.length>0));
    const heightValues=new Set(options.map(option=>option.dataset.height??'').filter(value=>value.length>0));
    const packValues=new Set(options.map(option=>option.dataset.pack??'').filter(value=>value.length>0));
    const hasCompleteChoices=(row            ,selector       ,expected            )        =>{
      const values=Array.from(row.querySelectorAll                  (selector),input=>input.value);
      return values.length===expected.size&&[...expected].every(value=>values.includes(value));
    };
    const canEnhance = bundleOptions && options.length === 36 && packRadios.length===3 && extraChoices.length===4 && colorRadios.length===36 && heightRadios.length===8 && colorValues.size===9 && heightValues.size===2 && packValues.size===2 && options.every(option => validVariant(option.value) && /^[1-9]\d{0,8}$/.test(option.dataset.priceCents??'') && keys.every(key => Boolean(option.dataset[key]))) && packRadios.every(radio=>packValues.has(radio.value)) && colorRadios.every(radio=>colorValues.has(radio.value)) && heightRadios.every(radio=>heightValues.has(radio.value)) && extraChoices.every(row=>hasCompleteChoices(row,'[data-pillow-color]',colorValues)&&hasCompleteChoices(row,'[data-pillow-height]',heightValues)) && radios.every(radio => {
      const key=keys[Number(radio.dataset.optionPosition)];
      return key && options.some(option=>option.dataset[key]===radio.value);
    });
    const update = ()       => {
      const option = select.selectedOptions.item(0);
      const count=quantity.value==='2'?2:1;
      const enabled = document.body.dataset.commerceEnabled === 'true';
      submit.disabled = bundleInFlight || form.dataset.submitting === 'true' || !enabled || !option || option.disabled || !validVariant(option.value);
      if (option?.dataset.price) amounts.forEach(amount => { amount.textContent = count===2?money(familyTotal(Number(option.dataset.priceCents))):option.dataset.price??''; });
      radios.forEach(radio => {
        const key=keys[Number(radio.dataset.optionPosition)];
        radio.disabled = !key || !options.some(candidate=>candidate.dataset[key]===radio.value && !candidate.disabled);
        radio.checked = Boolean(key && option?.dataset[key]===radio.value && (key!=='pack'||Number(radio.dataset.orderQuantity??1)===count));
        const card = radio.closest             ('[data-bundle-card]');
        if (card) {
          card.dataset.selected = String(radio.checked);
          card.dataset.unavailable = String(radio.disabled);
        }
      });
      const selectedPack=option?.dataset.pack??'';
      const pillowCount=selectedPack==='זוג כריות'?count*2:1;
      if(selectionGroup)selectionGroup.hidden=!option;
      if(selectionInstruction)selectionInstruction.textContent=pillowCount===1?'בחרו צבע וגובה לכרית שלכם.':`בחרו צבע וגובה לכל אחת מ-${pillowCount} הכריות.`;
      extraChoices.forEach((row,i)=>{
        row.hidden=!option||i>=pillowCount;
        const rowColors=Array.from(row.querySelectorAll                  ('[data-pillow-color]'));
        const rowHeights=Array.from(row.querySelectorAll                  ('[data-pillow-height]'));
        if(row.dataset.customized!=='true'){
          rowColors.forEach(input=>{input.checked=input.value===option?.dataset.color;});
          rowHeights.forEach(input=>{input.checked=input.value===option?.dataset.height;});
        }
        const selectedColor=rowColors.find(input=>input.checked)?.value??option?.dataset.color??'';
        const selectedHeight=rowHeights.find(input=>input.checked)?.value??option?.dataset.height??'';
        const colorLabel=row.querySelector             ('[data-selected-color]');
        if(colorLabel)colorLabel.textContent=selectedColor;
        rowColors.forEach(input=>{input.disabled=!options.some(candidate=>candidate.dataset.color===input.value&&candidate.dataset.height===selectedHeight&&candidate.dataset.pack===selectedPack&&!candidate.disabled);});
        rowHeights.forEach(input=>{input.disabled=!options.some(candidate=>candidate.dataset.color===selectedColor&&candidate.dataset.height===input.value&&candidate.dataset.pack===selectedPack&&!candidate.disabled);});
      });
      purchase.querySelectorAll             ('[data-pack-price]').forEach(item=>{
        const matching=options.find(candidate=>candidate.dataset.color===option?.dataset.color && candidate.dataset.height===option?.dataset.height && candidate.dataset.pack===item.dataset.packPrice);
        item.textContent=item.dataset.orderQuantity==='2'&&matching?money(familyTotal(Number(matching.dataset.priceCents))):matching?.dataset.price??'';
      });
      const gallery=form.closest             ('.product')?.querySelector             ('[data-gallery]');
      const thumbnail=Array.from(gallery?.querySelectorAll                   ('[data-gallery-color]')??[]).find(item=>item.dataset.galleryColor===option?.dataset.color);
      if(thumbnail && form.dataset.lastColor!==option?.dataset.color){
        if(form.dataset.lastColor)thumbnail.click();
        form.dataset.lastColor=option?.dataset.color??'';
      }
      if(thumbnail?.dataset.gallerySrc){
        const url=new URL(thumbnail.dataset.gallerySrc,window.location.origin);
        if(url.protocol==='https:'&& (url.origin===window.location.origin||url.hostname==='cdn.shopify.com') || url.origin===window.location.origin && url.protocol==='http:')purchase.querySelectorAll                  ('[data-bundle-image]').forEach(image=>{image.src=url.href;});
      }
    };
    const syncFirstPillowToVariant=()     =>{
      const firstChoice=extraChoices[0];
      const selectedPack=packRadios.find(radio=>radio.checked);
      if(!firstChoice||!selectedPack)return;
      const color=firstChoice.querySelector                  ('[data-pillow-color]:checked')?.value;
      const height=firstChoice.querySelector                  ('[data-pillow-height]:checked')?.value;
      const matching=options.find(candidate=>candidate.dataset.color===color&&candidate.dataset.height===height&&candidate.dataset.pack===selectedPack.value&&!candidate.disabled);
      if(!matching||!validVariant(matching.value))return;
      select.value=matching.value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
    };
    if (canEnhance) {
      bundleOptions.hidden = false;
      form.dataset.bundleEnhanced = 'true';
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const key=keys[Number(radio.dataset.optionPosition)];
          if(!key||!radio.checked)return;
          if(key==='pack')quantity.value=radio.dataset.orderQuantity==='2'?'2':'1';
          if(key==='pack')syncFirstPillowToVariant();
        });
      });
      [...colorRadios,...heightRadios].forEach(input=>input.addEventListener('change',()=>{
        if(!input.checked)return;
        const row=input.closest             ('[data-pillow-choice]');
        if(!row)return;
        row.dataset.customized='true';
        if(row.dataset.pillowIndex==='0')syncFirstPillowToVariant();
        else update();
      }));
    }
    select.addEventListener('change', update);
    form.addEventListener('submit', event => {
      const alreadySubmitting=bundleInFlight||form.dataset.submitting==='true';
      update();
      if (alreadySubmitting || submit.disabled || document.body.dataset.preview === 'true') {
        event.preventDefault();
        return;
      }
      if(canEnhance&&select.selectedOptions.item(0)?.dataset.pack==='זוג כריות'){
        event.preventDefault();
        const chosen=select.selectedOptions.item(0);if(!chosen)return;
        // Since D24 every pillow, the first one included, has its own visible choice row; the rows are the order.
        const choices               =extraChoices.filter(row=>!row.hidden).map(row=>({color:row.querySelector                  ('[data-pillow-color]:checked')?.value??'',height:row.querySelector                  ('[data-pillow-height]:checked')?.value??''}));
        let items                                    ;
        try{items=buildBundleItems(options.map(o=>({id:o.value,color:o.dataset.color??'',height:o.dataset.height??'',pack:o.dataset.pack??'',priceCents:Number(o.dataset.priceCents),available:!o.disabled})),choices);}catch{if(selectionStatus)selectionStatus.textContent='יש לבחור צבע וגובה זמינים לכל כרית.';return;}
        const cart=new URL(form.dataset.cartUrl??'/cart',location.origin);
        if(cart.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart\/?$/.test(cart.pathname))return;
        bundleInFlight=true;form.dataset.submitting='true';submit.disabled=true;submit.textContent='מוסיפים לסל…';
        // One Shopify request for both pairs. Never retry a POST whose result is
        // unknown; the customer checks the native cart before another attempt.
        void fetch(new URL(cart.pathname.replace(/\/$/,'')+'/add.js',location.origin),{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items}),signal:AbortSignal.timeout(30000)}).then(response=>{
          if(!response.ok)throw Error('Cart add failed');location.assign(cart.href);
        }).catch(()=>{if(selectionStatus){selectionStatus.textContent='לא התקבל אישור הוספה. יש לבדוק את הסל לפני ניסיון נוסף. ';const link=document.createElement('a');link.href=cart.href;link.textContent='לבדיקת הסל';selectionStatus.append(link);}submit.textContent='יש לבדוק את הסל';});
        return;
      }
      // Native POST navigates away. Block rapid second submission; no add retry.
      form.dataset.submitting = 'true';
      submit.disabled = true;
      submit.textContent = 'מוסיפים לסל…';
    });
    window.addEventListener('pageshow',event=>{
      if(!event.persisted)return;
      bundleInFlight=false;form.dataset.submitting='false';submit.textContent='הוספה לסל';update();
    });
    update();
  });
  root.querySelectorAll             ('[data-gallery]').forEach(gallery => {
    if (gallery.dataset.galleryMounted === 'true') return;
    const hero = gallery.querySelector                  ('[data-gallery-main]');
    if (!hero) return;
    gallery.dataset.galleryMounted = 'true';
    const thumbnails = Array.from(gallery.querySelectorAll                   ('[data-gallery-src]'));
    let active = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    // Arrow controls and thumbnails share this same allowlisted, instant update.
    const show = (button                   )       => {
      const raw = button.dataset.gallerySrc;
      if (!raw) return;
      let candidate     ;
      try { candidate = new URL(raw, window.location.origin); } catch { return; }
      if (candidate.origin !== window.location.origin && candidate.hostname !== 'cdn.shopify.com') return;
      if (!['http:', 'https:'].includes(candidate.protocol)) return;
      hero.src = candidate.href;
      hero.alt = button.dataset.alt ?? '';
      thumbnails.forEach(item => item.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      active = thumbnails.indexOf(button);
    };
    thumbnails.forEach(button => {
      button.addEventListener('click', () => show(button));
    });
    if (thumbnails.length > 1) {
      const controls = gallery.querySelector             ('[data-gallery-controls]');
      if (controls) controls.hidden = false;
      const previous = gallery.querySelector                   ('[data-gallery-prev]');
      const next = gallery.querySelector                   ('[data-gallery-next]');
      const step = (direction        )       => {
        const button = thumbnails[(active + direction + thumbnails.length) % thumbnails.length];
        if (button) show(button);
      };
      previous?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));
    }
    const selected=gallery.closest('.product')?.querySelector                   ('form.buy-form [name="id"]')?.selectedOptions.item(0)?.dataset.color;
    if(selected && selected!=='לבן'){
      const matching=thumbnails.find(button=>button.dataset.galleryColor===selected);
      if(matching)show(matching);
    }
  });
}
if (typeof document !== 'undefined') {
  mount();
  document.addEventListener('shopify:section:load', () => mount());
}
